module.exports = __webpack_public_path__ + "static/media/logo-mnisw.269ff659.png";